module.exports = __webpack_public_path__ + "img/card_informe_eden_child_count.afec9ec5.svg";